<template>
  <div class="data-access-toggle">
    <span class="mr-5 fw-bold">Study Data:</span>
    <span class="test-label">Test</span>
    <label class="switch">
      <input type="checkbox" :disabled="apiCallInProgress || allSitesSame" v-model="liveDataChild" @change="$emit('dataAccessViewChange', liveDataChild)" />
      <div class="slider round"></div>
    </label>
    <span class="live-label">Live</span>
  </div>
</template>

<script>
export default {
  name: "data-access-toggle",
  props: ["liveData", "apiCallInProgress", "allSitesSame"],
  data() {
    return {
      liveDataChild: this.liveData
    };
  }
};
</script>

<style scoped lang="scss">
/* The slider */
.switch {
  position: relative;
  display: inline-block;
  width: 40px;
  height: 17px;
  top: 5px;
  margin: 0 4px;
  &.left-switch {
    left: 14px;
  }
}
.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  border: 1px solid #b8c7ce;
}
.slider:before {
  position: absolute;
  content: "";
  height: 11px;
  width: 11px;
  left: 2px;
  bottom: 2px;
  background-color: #ccc;
}
input:checked + .slider {
  border: 1px solid#6bbb80;
}
input:checked + .slider:before {
  content: "";
  background-color: #48bf7a;
}
input:checked + .slider:before {
  position: absolute;
  color: #6bbb80;
  text-align: center;
  font-size: 20px;
  -webkit-transform: translateX(22px);
  -ms-transform: translateX(22px);
  transform: translateX(22px);
}
/* Hide default HTML checkbox */
.switch input {
  display: none;
}
/* Rounded sliders */
.slider.round {
  border-radius: 34px;
}
.slider.round:before {
  border-radius: 50%;
}
/* Rounded sliders */
.test-label {
  position: relative;
  &.move-left {
    left: 5px;
  }
}
.live-label {
  position: relative;
  &.on-left {
    left: 21px;
  }
}
.data-access-toggle {
  margin-left: auto;
  position: relative;
  bottom: 2px;
  right: 15px;
  font-size: 12px;
  color: #666669;
}
</style>
